<template>
  <div class="loan-body-wapper">
    <van-field v-model="product.bank" label="所属银行" readonly input-align="right" label-width="3rem"/>
    <van-field
      v-model="product.bankName"
      label="银行名称"
      readonly
      input-align="right"
      label-width="3rem"
    />
    <van-field v-model="product.name" label="产品名称" readonly input-align="right" label-width="3rem"/>
    <van-field
      v-model="product.productType"
      label="产品类型"
      readonly
      input-align="right"
      label-width="3rem"
    />

    <van-field
      v-model="product.custType"
      label="客群类型"
      readonly
      input-align="right"
      label-width="3rem"
    />
    <van-field
      v-model="product.target"
      label="面向对象"
      readonly
      input-align="right"
      label-width="3rem"
    />
    <van-field
      v-model="product.briefInfo"
      label="产品简介"
      readonly
      input-align="right"
      label-width="3rem"
    />
    <van-field v-model="product.rate" label="产品利率" readonly input-align="right" label-width="3rem"/>
    <van-field
      v-model="product.limitScales"
      label="利率浮动比例"
      readonly
      input-align="right"
      label-width="3rem"
    />

    <van-field
      v-model="product.proLimit"
      label="产品期限"
      readonly
      input-align="right"
      label-width="3rem"
    />
    <van-field
      v-model="product.quota"
      label="产品额度"
      readonly
      input-align="right"
      label-width="3rem"
    />

    <!-- <van-field
      v-model="product.quotaCales"
      label="额度浮动比例"
      readonly
      input-align="right"
      label-width="3rem"
    />-->
    <van-field
      v-model="product.pledgeType"
      label="抵质押要求"
      readonly
      input-align="right"
      label-width="3rem"
    />
    <van-field
      v-model="product.productFeature"
      label="产品特色"
      readonly
      input-align="right"
      label-width="3rem"
    />
    <van-field
      readonly
      v-model="product.applyType"
      label="在线办理标志"
      input-align="right"
      label-width="3rem"
    />
    <van-field
      v-model="product.applyUrl"
      label="在线办理URL"
      readonly
      input-align="right"
      label-width="3rem"
    />
    <van-field
      v-model="product.manualUrl"
      label="产品说明书URL"
      readonly
      input-align="right"
      label-width="3rem"
    />
    <van-field
      v-model="product.amName"
      label="客户经理姓名"
      readonly
      input-align="right"
      label-width="3rem"
    />
    <van-field
      v-model="product.amPhone"
      label="客户经理电话"
      readonly
      input-align="right"
      label-width="3rem"
    />
    <van-field
      v-model="product.amEmail"
      label="客户经理邮箱	"
      readonly
      input-align="right"
      label-width="3rem"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      product: {}
    };
  },
  components: {},
  created() {
    // this.JSBridge.setTitle(this.$route.query.name);
    // console.log(this.$route.query.name,122222222)
    this.product = this.$route.query;
    console.log(this.product, 258369);
    this.product.rate = this.formatPercent2(this.product.rate);
    this.product.limitScales = this.formatPercent2(this.product.limitScales);
    // this.product.quotaCales = this.formatPercent2(this.product.quotaCales);
    this.product.productType = this.getProductTypeNameByValue(
      this.product.productType
    );
    this.product.custType = this.getCustTypeNameByValue(this.product.custType);
    this.product.applyType = this.getApplyTypeNameByValue(
      this.product.applyType
    );
    this.product.bank = this.getBankNameByValue(this.product.bank);
    console.log("=======222222=", this.product.bank);
  },
  methods: {
    // 百分比格式化
    formatPercent2(point) {
      if ((point + "").indexOf("%") > 0) return point;

      if (null == point) {
        return "--";
      }
      var percent = (point * 100).toFixed(2);
      percent += "%";
      return percent;
    },
    getProductTypeNameByValue(val) {
      let productTypeList = [
        { text: "政策贷", value: "POLICY" },
        { text: "担保贷", value: "GUARANTEE" },
        { text: "出口贷", value: "EXPORT" }
      ];
      for (var index in productTypeList) {
        if (productTypeList[index].value == val)
          return productTypeList[index].text;
      }
      return "";
    },
    getCustTypeNameByValue(val) {
      let custTypeList = [
        { text: "企业贷", value: "CORP" },
        { text: "个人贷", value: "INDIVIDUAL" }
      ];
      for (var index in custTypeList) {
        if (custTypeList[index].value == val) return custTypeList[index].text;
      }
      return "";
    },
    getApplyTypeNameByValue(val) {
      let applyTypeList = [
        { text: "在线办理", value: "1" },
        { text: "线上申请", value: "2" },
        { text: "线下申请", value: "3" }
      ];
      for (var index in applyTypeList) {
        if (applyTypeList[index].value == val) return applyTypeList[index].text;
      }
      return "";
    },
    getBankNameByValue(val) {
      let bankList = [
        { text: "国家开发银行", value: "CDB" },
        { text: "中国工商银行", value: "ICBC" },
        { text: "中国农业银行", value: "ABC" },
        { text: "中国银行", value: "BOC" },
        { text: "中国建设银行", value: "CCB" },
        { text: "中国邮政储蓄银行", value: "PSBC" },
        { text: "交通银行", value: "COMM" },
        { text: "招商银行", value: "CMB" },
        { text: "上海浦东发展银行", value: "SPDB" },
        { text: "兴业银行", value: "CIB" },
        { text: "华夏银行", value: "HXBANK" },
        { text: "广东发展银行", value: "GDB" },
        { text: "中国民生银行", value: "CMBC" },
        { text: "中信银行", value: "CITIC" },
        { text: "中国光大银行", value: "CEB" },
        { text: "恒丰银行", value: "EGBANK" },
        { text: "浙商银行", value: "CZBANK" },
        { text: "渤海银行", value: "BOHAIB" },
        { text: "平安银行", value: "SPABANK" },
        { text: "上海农村商业银行", value: "SHRCB" },
        { text: "玉溪市商业银行", value: "YXCCB" },
        { text: "尧都农商行", value: "YDRCB" },
        { text: "北京银行", value: "BJBANK" },
        { text: "上海银行", value: "SHBANK" },
        { text: "江苏银行", value: "JSBANK" },
        { text: "杭州银行", value: "HZCB" },
        { text: "南京银行", value: "NJCB" },
        { text: "宁波银行", value: "NBBANK" },
        { text: "徽商银行", value: "HSBANK" },
        { text: "长沙银行", value: "CSCB" },
        { text: "成都银行", value: "CDCB" },
        { text: "重庆银行", value: "CQBANK" },
        { text: "大连银行", value: "DLB" },
        { text: "南昌银行", value: "NCB" },
        { text: "福建海峡银行", value: "FJHXBC" },
        { text: "汉口银行", value: "HKB" },
        { text: "温州银行", value: "WZCB" },
        { text: "青岛银行", value: "QDCCB" },
        { text: "台州银行", value: "TZCB" },
        { text: "嘉兴银行", value: "JXBANK" },
        { text: "常熟农村商业银行", value: "CSRCB" },
        { text: "南海农村信用联社", value: "NHB" },
        { text: "常州农村信用联社", value: "CZRCB" },
        { text: "内蒙古银行", value: "H3CB" },
        { text: "绍兴银行", value: "SXCB" },
        { text: "顺德农商银行", value: "SDEB" },
        { text: "吴江农商银行", value: "WJRCB" },
        { text: "齐商银行", value: "ZBCB" },
        { text: "贵阳市商业银行", value: "GYCB" },
        { text: "遵义市商业银行", value: "ZYCBANK" },
        { text: "湖州市商业银行", value: "HZCCB" },
        { text: "龙江银行", value: "DAQINGB" },
        { text: "晋城银行JCBANK", value: "JINCHB" },
        { text: "浙江泰隆商业银行", value: "ZJTLCB" },
        { text: "广东省农村信用社联合社", value: "GDRCC" },
        { text: "东莞农村商业银行", value: "DRCBCL" },
        { text: "浙江民泰商业银行", value: "MTBANK" },
        { text: "广州银行", value: "GCB" },
        { text: "辽阳市商业银行", value: "LYCB" },
        { text: "江苏省农村信用联合社", value: "JSRCU" },
        { text: "廊坊银行", value: "LANGFB" },
        { text: "浙江稠州商业银行", value: "CZCB" },
        { text: "德阳商业银行", value: "DYCB" },
        { text: "晋中市商业银行", value: "JZBANK" },
        { text: "苏州银行", value: "BOSZ" },
        { text: "桂林银行", value: "GLBANK" },
        { text: "乌鲁木齐市商业银行", value: "URMQCCB" },
        { text: "成都农商银行", value: "CDRCB" },
        { text: "张家港农村商业银行", value: "ZRCBANK" },
        { text: "东莞银行", value: "BOD" },
        { text: "莱商银行", value: "LSBANK" },
        { text: "北京农村商业银行", value: "BJRCB" },
        { text: "天津农商银行", value: "TRCB" },
        { text: "上饶银行", value: "SRBANK" },
        { text: "富滇银行", value: "FDB" },
        { text: "重庆农村商业银行", value: "CRCBANK" },
        { text: "鞍山银行", value: "ASCB" },
        { text: "宁夏银行", value: "NXBANK" },
        { text: "河北银行", value: "BHB" },
        { text: "华融湘江银行", value: "HRXJB" },
        { text: "自贡市商业银行", value: "ZGCCB" },
        { text: "云南省农村信用社", value: "YNRCC" },
        { text: "吉林银行", value: "JLBANK" },
        { text: "东营市商业银行", value: "DYCCB" },
        { text: "昆仑银行", value: "KLB" },
        { text: "鄂尔多斯银行", value: "ORBANK" },
        { text: "邢台银行", value: "XTB" },
        { text: "晋商银行", value: "JSB" },
        { text: "天津银行", value: "TCCB" },
        { text: "营口银行", value: "BOYK" },
        { text: "吉林农信", value: "JLRCU" },
        { text: "山东农信", value: "SDRCU" },
        { text: "西安银行", value: "XABANK" },
        { text: "河北省农村信用社", value: "HBRCU" },
        { text: "宁夏黄河农村商业银行", value: "NXRCU" },
        { text: "贵州省农村信用社", value: "GZRCU" },
        { text: "阜新银行", value: "FXCB" },
        { text: "湖北银行黄石分行", value: "HBHSBANK" },
        { text: "浙江省农村信用社联合社", value: "ZJNX" },
        { text: "新乡银行", value: "XXBANK" },
        { text: "湖北银行宜昌分行", value: "HBYCBANK" },
        { text: "乐山市商业银行", value: "LSCCB" },
        { text: "江苏太仓农村商业银行", value: "TCRCB" },
        { text: "驻马店银行", value: "BZMD" },
        { text: "赣州银行", value: "GZB" },
        { text: "无锡农村商业银行", value: "WRCB" },
        { text: "广西北部湾银行", value: "BGB" },
        { text: "广州农商银行", value: "GRCB" },
        { text: "江苏江阴农村商业银行", value: "JRCB" },
        { text: "平顶山银行", value: "BOP" },
        { text: "泰安市商业银行", value: "TACCB" },
        { text: "南充市商业银行", value: "CGNB" },
        { text: "重庆三峡银行", value: "CCQTGB" },
        { text: "中山小榄村镇银行", value: "XLBANK" },
        { text: "邯郸银行", value: "HDBANK" },
        { text: "库尔勒市商业银行", value: "KORLABANK" },
        { text: "锦州银行", value: "BOJZ" },
        { text: "齐鲁银行", value: "QLBANK" },
        { text: "青海银行", value: "BOQH" },
        { text: "阳泉银行", value: "YQCCB" },
        { text: "盛京银行", value: "SJBANK" },
        { text: "抚顺银行", value: "FSCB" },
        { text: "郑州银行", value: "ZZBANK" },
        { text: "深圳农村商业银行", value: "SRCB" },
        { text: "潍坊银行", value: "BANKWF" },
        { text: "九江银行", value: "JJBANK" },
        { text: "江西省农村信用", value: "JXRCU" },
        { text: "河南省农村信用", value: "HNRCU" },
        { text: "甘肃省农村信用", value: "GSRCU" },
        { text: "四川省农村信用", value: "SCRCU" },
        { text: "广西省农村信用", value: "GXRCU" },
        { text: "陕西信合", value: "SXRCCU" },
        { text: "武汉农村商业银行", value: "WHRCB" },
        { text: "宜宾市商业银行", value: "YBCCB" },
        { text: "昆山农村商业银行", value: "KSRB" },
        { text: "石嘴山银行", value: "SZSBK" },
        { text: "衡水银行", value: "HSBK" },
        { text: "信阳银行", value: "XYBANK" },
        { text: "鄞州银行", value: "NBYZ" },
        { text: "张家口市商业银行", value: "ZJKCCB" },
        { text: "许昌银行", value: "XCYH" },
        { text: "济宁银行", value: "JNBANK" },
        { text: "开封市商业银行", value: "CBKF" },
        { text: "威海市商业银行", value: "WHCCB" },
        { text: "湖北银行", value: "HBC" },
        { text: "承德银行", value: "BOCD" },
        { text: "丹东银行", value: "BODD" },
        { text: "金华银行", value: "JHBANK" },
        { text: "朝阳银行", value: "BOCY" },
        { text: "临商银行", value: "LSBC" },
        { text: "包商银行", value: "BSB" },
        { text: "兰州银行", value: "LZYH" },
        { text: "周口银行", value: "BOZK" },
        { text: "德州银行", value: "DZBANK" },
        { text: "三门峡银行", value: "SCCB" },
        { text: "安阳银行", value: "AYCB" },
        { text: "安徽省农村信用社", value: "ARCU" },
        { text: "湖北省农村信用社", value: "HURCB" },
        { text: "湖南省农村信用社", value: "HNRCC" },
        { text: "广东南粤银行", value: "NYNB" },
        { text: "洛阳银行", value: "LYBANK" },
        { text: "农信银清算中心", value: "NHQS" },
        { text: "城市商业银行资金清算中心", value: "CBBQS" }
      ];
      for (var index in bankList) {
        if (bankList[index].value == val) return bankList[index].text;
      }
      return "";
    }
  }
};
</script>

<style  lang="less" scoped>
.loan-body-wapper {
  padding: 0rem 0rem;
  font-size: 0.29rem;
}
</style>